<template>
  <div class="page-nav">
    <div class="page-nav-label">
      <span
        v-if="imageURL !== PopupPage.main && imageURL !== PopupPage.jackpot"
        @click="handleURLCallback"
        :class="{ hoverable: toURL }"
      >
        <img v-if="popupLevel === 1" class="menu-icon" :src="getImgUrl(imageURL)" />
        <img v-else class="menu-icon" src="@/assets/images/history-detail.webp" />
      </span>
      <slot />
    </div>
  </div>
</template>
<script>
import { getImgUrl } from '@/utils/helpers';
import { PopupPage } from '@/utils/index.model';
import { mapActions } from 'vuex';

export default {
  props: {
    imageURL: {
      type: String,
      required: true,
      default: 'results',
    },
    toURL: {
      type: String,
      default: '',
    },
    popupLevel: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      getImgUrl,
      PopupPage,
    };
  },
  methods: {
    ...mapActions('menu', ['updateMenu']),
    handleURLCallback() {
      if (!this.toURL) return;
      this.updateMenu({ activePopupPage: this.toURL });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-nav {
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  box-sizing: border-box;

  &-label {
    .hoverable {
      cursor: pointer;
    }
  }

  & > div {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
  }

  &-label {
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
  }
}
</style>
